import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";

const LINK_RE = /\[([^\]]+)\]\((\/[^)\s]*)\)/g;

/** Strip markdown-style links back to plain text (for JSON-LD, meta, etc.). */
export function stripLinks(text: string): string {
  return text.replace(LINK_RE, "$1");
}

/**
 * Render copy that may contain markdown-style internal links:
 * "estimates are [free](/request-estimate)".
 */
export function richText(text: string): ReactNode {
  const nodes: ReactNode[] = [];
  let last = 0;
  let match: RegExpExecArray | null;
  LINK_RE.lastIndex = 0;
  while ((match = LINK_RE.exec(text)) !== null) {
    if (match.index > last) nodes.push(text.slice(last, match.index));
    nodes.push(
      <Link
        key={`${match[2]}-${match.index}`}
        to={match[2] as never}
        className="font-medium text-brand underline underline-offset-4 hover:text-brand/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand"
      >
        {match[1]}
      </Link>,
    );
    last = match.index + match[0].length;
  }
  if (last < text.length) nodes.push(text.slice(last));
  return nodes.length === 1 ? nodes[0] : <>{nodes}</>;
}
